import { makeDefinitionFor } from '../../../helpers/endpoint.definition.details.generator';
import { generateValidationError, success } from '../../../shared/api.response.def';
import { form } from '../../../shared/form.def';

export const definition = makeDefinitionFor(
	'/form/{form_id}.json',
	{
		description: 'Get information on a single form',
		method: 'get',
		summary: 'Form Information',
		tags: ['Form'],
		params: [
			{
				$ref: '#/components/parameters/ikeDepartmentId',
			},
			{
				$ref: '#/components/parameters/formIdPath',
			},
		],
	},
	[
		{
			code: 200,
			description: success,
			schema: form,
		},
		generateValidationError(),
	]
);
